exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activity-log-toggle{font-size:.85em;transition:all .3s ease}.open .activity-log-toggle{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.activity-log-wrapper{overflow-x:hidden;overflow-y:auto;margin-top:40px;margin-bottom:40px;padding:0 7px}.activity-log-title{padding:0 5px 0 0;font-size:1rem}.activity-log-properties{border-left:1px solid #ccc;margin-left:18px}.activity-log-property{font-size:1rem;background:#ccc;color:#fff;display:inline-block;padding:1px 5px;border-top-right-radius:2px;border-bottom-right-radius:2px}.activity-log-diff{margin-left:36px;font-size:.85em;margin-top:4px;margin-bottom:4px}.activity-log-diff-item{width:50%;float:left}.activity-log-date{font-size:.85rem;color:#7b7e8a;float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e1ba7788","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/metronic/ActivityLog.vue
// module id = HgH2
// module chunks = 0 1 2